import {
  GET_CREATE_MATERIAL_RETURN_ORDER_REQUEST,
  GET_CREATE_MATERIAL_RETURN_ORDER_SUCCESS,
  GET_CREATE_MATERIAL_RETURN_ORDER_FAILURE,
} from "./createMaterialReturnOrderTypes";

const initialState = {
  loading: false,
  materialReturnOrders: [],
  error: "",
};

const getCreateMaterialReturnOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CREATE_MATERIAL_RETURN_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CREATE_MATERIAL_RETURN_ORDER_SUCCESS:
      return {
        loading: false,
        materialReturnOrders: action.payload,
        error: "",
      };
    case GET_CREATE_MATERIAL_RETURN_ORDER_FAILURE:
      return {
        loading: false,
        materialReturnOrders: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getCreateMaterialReturnOrderReducer };
